import { FormikProps } from 'formik'
import * as React from 'react'
import PhoneInput from 'react-phone-number-input/input'
import { IUserRegisterFormData } from '../../types/index'
import UserName from '../icons/auth/UserName'
import Email from '../icons/auth/Email'
import Phone from '../icons/auth/Phone'
import Calendar from '../icons/auth/Calendar'
import 'react-phone-number-input/style.css'

const RegisterForm = (props: FormikProps<IUserRegisterFormData>) => {
  const { values, touched, errors, handleSubmit, handleChange, isSubmitting, setFieldTouched, setFieldValue } = props

  const handleEmailField = (event: any) => {
    setFieldTouched('email')
    setFieldValue('username', event.target.value)
    setFieldValue('email', {
      emailAddress: event.target.value
    })
  }

  const handlePhoneField = (value: any) => {
    setFieldTouched('phones')
    setFieldValue('phones', [
      {
        phoneNumber: value,
        countryCode: '+1',
        isPrimary: true
      }
    ])
  }

  return (
    <form className='w310 mt4' onSubmit={handleSubmit}>
      <div className='flex items-center'>
        <div>
          <div className='flex items-center'>
            <UserName className='mr1' />
            <input
              className='p1 outline-none bg-transparent border-none bb-white'
              type='text'
              name='firstName'
              value={values.firstName}
              onChange={handleChange}
              placeholder='First Name'
            />
          </div>
          {errors.firstName && touched.firstName && <div className='font-orange right-align'>{errors.firstName}</div>}
        </div>
        <div>
          <div className='flex items-center'>
            <input
              className='p1 outline-none bg-transparent border-none bb-white'
              type='text'
              name='lastName'
              value={values.lastName}
              onChange={handleChange}
              placeholder='Last Name'
            />
          </div>
          {errors.lastName && touched.lastName && <div className='font-orange right-align'>{errors.lastName}</div>}
        </div>
      </div>
      <div className='flex items-center mt2'>
        <Email className='mr1' />
        <input
          className='p1 outline-none bg-transparent border-none bb-white w100'
          type='email'
          name='email'
          value={values.email.emailAddress}
          onChange={handleEmailField}
          placeholder='Email'
        />
      </div>
      {errors.email && touched.email && <div className='font-orange right-align'>{errors.email.emailAddress}</div>}
      <div className='flex items-center mt2'>
        <Phone className='mr1' />
        <PhoneInput
          className='p1 outline-none bg-transparent border-none bb-white w100'
          placeholder='Phone number'
          country='US'
          value={(values.phones[0] || {}).phoneNumber}
          onChange={handlePhoneField}
        />
      </div>
      {errors.phones && touched.phones && <div className='font-orange right-align'>{errors.phones}</div>}
      <div
        className='flex items-center mt2'
        style={{
          display: 'none'
        }}
      >
        <input
          className='p1 outline-none bg-transparent border-none bb-white w100'
          type='password'
          name='password-confirm'
          value={values.password}
          onChange={handleChange}
          placeholder='Password'
        />
      </div>
      {errors.password && touched.password && <div className='block font-orange right-align'>{errors.password}</div>}
      <button
        className='SignIn col-12 py2 h3 cursor--pointer border-none mt2 rounded bg-white box-sizing font-green'
        disabled={isSubmitting}
      >
        Sign up
      </button>
    </form>
  )
}

export default RegisterForm



// WEBPACK FOOTER //
// ./src/components/authentication/RegisterForm.tsx